import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {Station} from "../models/Station";
import {catchError, map} from "rxjs/operators";
import {StationResponse} from "../models/StationResponse";
import {environment} from "../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class StationService {

    private apiUrl = environment.parameters_url;
    private url = environment.url_images;
    private baseUrl = `${this.apiUrl}api/settings/station`;
    private usersStationsUrl = `${environment.apiUrl}api/users/stations`;

    constructor(private http: HttpClient) {
    }

    getStationById(stationId: number): Observable<Station> {
        return this.http.get<any>(`${this.baseUrl}/${stationId}`).pipe(
            map(response => response.station)
        );
    }

    getStation(id: number, clientId?: number): Observable<any> {
        const sid = Math.floor(Number(id));
        const cid = clientId != null ? Math.floor(Number(clientId)) : 0;
        const qs = Number.isFinite(cid) && cid > 0 ? `?client_id=${cid}` : '';
        return this.http.get<any>(`${this.baseUrl}/${sid}${qs}`);
    }

    /** Toutes les stations / établissements d’un compte client. */
    getStationsByClient(clientId: number): Observable<any[]> {
        const id = Math.floor(Number(clientId));
        if (!Number.isFinite(id) || id <= 0) {
            return of([]);
        }
        return this.http.get<any>(`${this.usersStationsUrl}/client/${id}`).pipe(
            map((res) => (res?.success && Array.isArray(res.stations) ? res.stations : [])),
            catchError(() => of([]))
        );
    }

    addStation(station: any): Observable<any> {
        return this.http.post<any>(`${this.baseUrl}`, station);
    }

    updateStation(stationId: number, station: any): Observable<any> {
        return this.http.put<any>(`${this.baseUrl}/${stationId}`, station);
    }

    uploadFile(fileData: FormData) {
        // Même host que l'API ERP (trailing slash géré) — évite un POST upload cassé
        const base = String(this.apiUrl || this.url || '').replace(/\/$/, '');
        return this.http.post<{
            path: string;
            name: string;
            url: string }>(`${base}/api/uploadfile`, fileData);
    }
}
